var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2477 6.16695C17.0825 5.62179 15.8367 5.2256 14.5342 5C14.3742 5.28921 14.1873 5.6782 14.0585 5.98764C12.6739 5.77941 11.302 5.77941 9.94287 5.98764C9.81404 5.6782 9.62292 5.28921 9.46152 5C8.15761 5.2256 6.91032 5.62325 5.74514 6.16984C3.39498 9.72124 2.75789 13.1844 3.07644 16.5984C4.63519 17.7625 6.14581 18.4696 7.63093 18.9323C7.99762 18.4277 8.32465 17.8912 8.60638 17.3258C8.06981 17.1219 7.5559 16.8703 7.07031 16.5782C7.19913 16.4828 7.32514 16.383 7.44689 16.2803C10.4086 17.6656 13.6267 17.6656 16.5531 16.2803C16.6762 16.383 16.8022 16.4828 16.9296 16.5782C16.4426 16.8717 15.9273 17.1233 15.3907 17.3273C15.6724 17.8912 15.9981 18.4291 16.3662 18.9338C17.8527 18.471 19.3647 17.7639 20.9235 16.5984C21.2973 12.6407 20.285 9.20935 18.2477 6.16695ZM9.00988 14.4989C8.12079 14.4989 7.39166 13.6688 7.39166 12.6581C7.39166 11.6473 8.10522 10.8159 9.00988 10.8159C9.91457 10.8159 10.6437 11.6459 10.6281 12.6581C10.6295 13.6688 9.91457 14.4989 9.00988 14.4989ZM14.9901 14.4989C14.101 14.4989 13.3718 13.6688 13.3718 12.6581C13.3718 11.6473 14.0854 10.8159 14.9901 10.8159C15.8947 10.8159 16.6238 11.6459 16.6083 12.6581C16.6083 13.6688 15.8947 14.4989 14.9901 14.4989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordM);
export default __webpack_public_path__ + "static/media/discord-m.ce15b7fed732b54b1c77a9b7e9936a3d.svg";
export { ForwardRef as ReactComponent };